export const modalReturn = {
  modal: {
    returnedAt: 'Returned At',
    btnReturn: 'Return',
    btnCancel: 'Cancel',
    titleModal: 'Do you want to return uniform?',
  },
}
